export default __webpack_public_path__ + "static/broadcastImg2-fa824a2ccb3157aea9dd955af78e9254.webp";